module.exports = __webpack_public_path__ + "assets/img/insta_w.0ada2ab4.svg";